/**
 * Normalize nozzle-allocation employee rows into react-select options.
 * API rows are stored as [emp_id, emp_name]; objects are also accepted.
 */
export function toEmployeeSelectOptions(dropdownData) {
	const list = Array.isArray(dropdownData) ? dropdownData : [];
	const options = [];
	const seen = new Set();

	list.forEach((row) => {
		if (row == null) {
			return;
		}

		let id;
		let name;
		if (Array.isArray(row)) {
			id = row[0];
			name = row[1];
		} else {
			id = row.emp_id ?? row.id ?? row.value;
			name = row.emp_name ?? row.name ?? row.label;
		}

		if (id === undefined || id === null || String(id).trim() === '') {
			return;
		}

		const value = String(id);
		if (seen.has(value)) {
			return;
		}
		seen.add(value);
		const label = String(name ?? '').trim();
		options.push({
			value,
			label: label || `Employee ${value}`,
		});
	});

	return options;
}

export function findEmployeeOption(options, employeeId) {
	const value = String(employeeId ?? '');
	if (!value) {
		return null;
	}
	return (options || []).find((option) => option.value === value) || {
		value,
		label: 'Selected employee',
	};
}
